import React from 'react';
import { PrimaryBanner as Banner } from '@belong/ui-components';
import type { IPrimaryBanner } from '@belong/types';

const PrimaryBanner: React.FC<IPrimaryBanner> = (props: IPrimaryBanner) => <Banner {...props} />;

export default PrimaryBanner;
